// src/components/kuestion/shared/openSitting.js
//
// A note the exam runner leaves while a sitting is open, so the sign-in page
// can say "your exam is still open" instead of a generic sign-in (Preferences
// & Timezone build brief §15; client response v5.3 §3.2). Tokens live in
// sessionStorage and die with the tab; this lives in localStorage precisely
// because it must outlive the tab that lost the token.
//
// It is a hint, not a credential: nothing is granted by it. The sitting
// resume ticket that re-attaches silently is the backend's half and is
// still to come in the token/TTL contract.
import { storageKey } from '../../../config/routes';

export const OPEN_SITTING_KEY = storageKey('kuestion', 'sitting.open');
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // longer than any paper plus its grace

export function noteOpenSitting(assignmentId, name) {
  try { localStorage.setItem(OPEN_SITTING_KEY, JSON.stringify({ id: String(assignmentId), name: name || '', at: Date.now() })); } catch { /* private mode */ }
}

export function clearOpenSitting(assignmentId) {
  try {
    if (assignmentId != null) {
      const cur = readOpenSitting();
      if (cur && cur.id !== String(assignmentId)) return; // another sitting's note
    }
    localStorage.removeItem(OPEN_SITTING_KEY);
  } catch { /* private mode */ }
}

/** The open sitting, or null when there is none or the note is stale. */
export function readOpenSitting() {
  try {
    const v = JSON.parse(localStorage.getItem(OPEN_SITTING_KEY) || 'null');
    if (!v || !v.id) return null;
    if (!v.at || Date.now() - v.at > MAX_AGE_MS) { localStorage.removeItem(OPEN_SITTING_KEY); return null; }
    return v;
  } catch { return null; }
}
